import React from 'react';
import { Link } from 'react-router-dom';
import SthenusLogo from '../../../assets/sthenus-logo.png';
import SthenusLogoIcon from '../../../assets/sthenus-logo-icon.png';

const Logo = ({ collapsed }) => (
  <h1 className="pointer mb-0" style={{ margin: 0 }}>
    <Link
      className={`sthenus-logo-wrap${collapsed ? ' sthenus-logo-wrap--collapsed' : ''}`}
      to="/"
      style={{ textDecoration: 'none' }}
    >
      <img
        src={collapsed ? SthenusLogoIcon : SthenusLogo}
        alt="Sthenus"
      />
    </Link>
  </h1>
);

export default Logo;
